import React from 'react'
import { withRouter } from 'react-router-dom'
import { I18n } from 'react-i18next'

// FIXME: active class not working, component is not updating in some cases...

const A = ({ children, className, history, href, onClick, target, t, scrollToTopOnClick, style }) => {
  
  function isLocal(href) {
    return href !== undefined && href != null && !href.match(/^http[s]?:\/\//i) /*&& !href.match(/^\/\//i) */
  }
  function isEmail(href) {
    return href !== undefined && href != null && href.match(/^mailto:/i) 
  }
  function isTel(href) {
    return href !== undefined && href != null && href.match(/^tel:/i) 
  }

  function classNameWithExtension(href) {
    const result = []
    if (className)
      result.push(className)
    if(href){
      if (history.location.pathname.includes(href))
      result.push('active')
      const match = href.match(/^http[s]?:\/\/.+\.(pdf|pptx|zip|jpg|jpeg)$/i)
      if (match && match[1]) {
        result.push('icon-' + match[1])
      }
    }
    return result.join(' ')
  }
  const handleClick = e => {
    let href = e.currentTarget.getAttribute('href');
    if (isLocal(href)) {
      e.preventDefault();
      history.push(href);
      scrollToTopOnClick && window.scrollTo(0,0);
    }
    if (onClick)
      onClick(e)
  }
  function prepareHref(t){
    if(href === undefined || href ===null)
      return null;
    if(isEmail(href))
      return href;
    if(isTel(href))
      return href;
    if(isLocal(href))
      return t('common:urlPrefix') + href;
    return href;
  }
  
  return (
    <I18n>
      {
        t => (
          <a style={style} className={classNameWithExtension(prepareHref(t))} href={prepareHref(t)} rel="nofollow" onClick={handleClick} target={target}>
            {children}
          </a>
        )
      }
    </I18n>
  )

}

export default withRouter(A)



// WEBPACK FOOTER //
// ./src/components/A.js